"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const secp256k1_1 = require("./secp256k1");
exports.SECP256K1Client = secp256k1_1.SECP256K1Client;
const cryptoClients = {
    ES256K: secp256k1_1.SECP256K1Client
};
exports.cryptoClients = cryptoClients;
//# sourceMappingURL=index.js.map